import { isNull, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidCurrentActivity = data => {
    return validateCurrentActivityStep(get(data, ["currentActivity", "value"], "")) && !data.currentActivity.isValid
}

export const validateCurrentActivityStep = value => {
    return !isNull(value)
}

export const currentActivityData = {
    home: {
        value: "home",
        title: locales[window.userLang].fitness_at_home,
        icon: "img/icon-home.png"
    },
    walking: {
        value: "walking",
        title: locales[window.userLang].walking,
        icon: "img/icon-walking.png"
    },
    running: {
        value: "running",
        title: locales[window.userLang].running,
        icon: "img/icon-running.png"
    },
    yoga: {
        value: "yoga",
        title: locales[window.userLang].yoga_at_home,
        icon: "img/icon-yoga.png"
    },
    dance: {
        value:"dance",
        title: locales[window.userLang].dance_at_home,
        icon: "img/icon-dance.png"
    },
}